export default class Validator {
  static isNullOrEmpty = function (value) {
    let trimmedValue = (typeof value === 'string' ? value.trim() : value);
    return trimmedValue == null || trimmedValue === "";
  }
  static isNumber = function (value) {
    let trimmedValue = (typeof value === 'string' ? value.trim() : value);
    return /[0-9]+/.test(trimmedValue);
  }
  static isPhone = function (value) {
    let trimmedValue = (typeof value === 'string' ? value.trim() : value);
    return /^(?:\+?1[ -]?)?(?:\([0-9]{3}\))?(?:[0-9]{3})?[ -]?[0-9]{3}[ -]?[0-9]{4}$/m.test(trimmedValue);
  }
  static hasInvalidPhoneChars = function (value) {
    let trimmedValue = (typeof value === 'string' ? value.trim() : value);
    return /[^+0-9() -]/m.test(trimmedValue) ||
    (trimmedValue.length > 4 &&
      /\(/m.test(trimmedValue) &&
      !/\([0-9]{3}\)/m.test(trimmedValue))
  }
  static formatPhone = function (value) {
    let trimmedValue = (typeof value === 'string' ? value.trim() : value);
    let formattedValue = trimmedValue.replace(/[^0-9]/g, '');
    if (formattedValue.length == 11) {
      formattedValue = formattedValue.substring(1);
    }
    return formattedValue;
  }
  static isEmail = function (value) {
    let trimmedValue = (typeof value === 'string' ? value.trim() : value);
   // return /^[A-Z0-9.+_-]+@[A-Z][A-Z0-9-]+?[A-Z0-9](?:\.[A-Z0-9][A-Z0-9-]+?[A-Z0-9])+$/im.test(trimmedValue);
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/im.test(trimmedValue);
  }
  static hasInvalidEmailChars = function (value) {
    let trimmedValue = (typeof value === 'string' ? value.trim() : value);
    return /[^A-Z0-9.+_@-]/im.test(trimmedValue);
  }
  static formatEmail = function (value) {
    let trimmedValue = (typeof value === 'string' ? value.trim() : value);
    return trimmedValue.toLowerCase();
  }
  static isAbove = function (value, min) {
    let currentVal = (min instanceof Date) ? new Date(value) : value;
    if (currentVal <= min) {
      return false;
    }
    return true;
  }
  static isBelow = function (value, max) {
    let currentVal = (max instanceof Date) ? new Date(value) : value;
    if (currentVal >= max) {
      return false;
    }
    return true;
  }

  static getErrors = function (data, validation) {
    let errors = {};
    Object.keys(validation).forEach((key) => {
      this.validateField({ errors: errors, data: data, name: key, validation: validation[key] });
    });
    return errors;
  }
  static validateField = function ({ errors: errors, data, name, validation }) {
    let validationResult = {};

    // A string value signifies simple presence validation, with the string being error message to display.
    if (typeof (validation) === 'string') {
      if (this.isNullOrEmpty(data[name])) {
        errors[name] = validation;
        return false;
      }
      // End of presence validation.
      return true;
    }
    // An object signifies complex validation
    if (typeof (validation) == 'object') {
      // If required string is set, validate presence
      if (validation.required) {
        if (this.isNullOrEmpty(data[name])) {
          errors[name] = validation.required;
          return false;
        }
      }
      // If type object is set, validate each key type
      if (validation.type) {
        Object.keys(validation.type).forEach((currentType) => {
          // If a group, check each child for presence. If any child is present, pass its validation.
          if (currentType == 'group') {
            if (validation.children) {
              if (Array.isArray(validation.children)) {
                let validChildren = false;
                validation.children.forEach((child) => {
                  if (data[child])
                    validChildren = true;
                });
                if (!validChildren)
                  errors[name] = validation.type[currentType];
                return validChildren;
              }
              let childPresence = {};
              // Test for the presence of each child
              Object.keys(validation.children).forEach((child) => {
                this.validateField({
                  errors: childPresence,
                  data: data,
                  name: child,
                  validation: "",
                });
              });
              let emptyChildren = Object.keys(childPresence);
              // If children are all empty, fail validation
              if (emptyChildren.length == Object.keys(validation.children).length) {
                errors[name] = validation.type[currentType];
                return false;
              }
              // If any children have values, validate them
              if (typeof (validation.children) == 'object') {
                Object.keys(validation.children).forEach((child) => {
                  // Only validate children that have values
                  if (!emptyChildren.includes(child))
                    this.validateField({
                      errors: errors,
                      data: data,
                      name: child,
                      validation: validation.children[child]
                    });
                });
              }
              return true;
            } else {
              errors[name] = "No children found for validation.";
              return false;
            }
          }
          // If not a group, check for other types
          if (this.isNullOrEmpty(data[name]))
            return true;

          switch (currentType) {
            case 'number':
              if (!this.isNumber(data[name])) {
                errors[name] = validation.type[currentType];
                return false;
              }
              break;
            case 'phone':
              if (!this.isPhone(data[name])) {
                errors[name] = validation.type[currentType];
                return false;
              }
              break;
            case 'email':
              if (!this.isEmail(data[name])) {
                errors[name] = validation.type[currentType];
                return false;
              }
              break;
            case 'range':
              if (!this.isAbove(data[name], validation.type[currentType].min)) {
                errors[name] = validation.type[currentType].minError;
                return false;
              }
              if (!this.isBelow(data[name], validation.type[currentType].max)) {
                errors[name] = validation.type[currentType].maxError;
                return false;
              }
              break;
            default:
              errors[name] = "Unknown validation type.";
              return false;
          }
        });
      }
      // If condition is set, conditionally validate children
      if (validation.condition) {
        if (validation.children) {
          if (validation.condition == data[name] || (typeof(data[name]) != 'boolean' && validation.condition === true && data[name] !== null)) {
            Object.keys(validation.children).forEach((child) => {
              this.validateField({
                errors: errors,
                data: data,
                name: child,
                validation: validation.children[child]
              });
            });
          }
        } else {
          errors[name] = "No children found for validation.";
          return false;
        }
      }
      // If notcondition is set, conditionally validate children
      if (validation.notcondition) {
        if (validation.children) {
          if (validation.notcondition != data[name]) {
            Object.keys(validation.children).forEach((child) => {
              this.validateField({
                errors: errors,
                data: data,
                name: child,
                validation: validation.children[child]
              });
            });
          }
        } else {
          errors[name] = "No children found for validation.";
          return false;
        }
      }
    }
    return validationResult;
  }
}